import { render, staticRenderFns } from "./VenteNew.vue?vue&type=template&id=3aa5b9fa&"
import script from "./VenteNew.vue?vue&type=script&lang=js&"
export * from "./VenteNew.vue?vue&type=script&lang=js&"
import style0 from "./VenteNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports